module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<a href="#" class="backtotop"></a>';

}
return __p
};
